<template>
  <div id="app">
    <img src="./assets/banner.jpg" alt class="bg" />
    <div class="Mine">
      <div class="left">
        <img src="./assets/icon.png" alt class="icon" />
        <span class="mypoints">我的积分:</span>
        <span class="points">{{myoptions}}</span>
      </div>
      <div class="right">
        <button class="btn" @click="handleClose({type:'Rule'})">兑换规则</button>
        <button class="btn" @click="handleClose({type:'goodslist'})">兑换记录</button>
      </div>
    </div>
    <div class="content">
      <h1 class="title">
        <span :class="{tab:true,on:idx===current}" 
        v-for="(item,idx) in tab" 
        :key="idx"
        @click="current=idx"
        >{{item}}</span>
      </h1>
      <ul class="list">
        <li class="item" v-for="item in goodsNum" :key="item.id">
          <div class="img">
            <img :src="item.mallGoods.picture" :alt="item.goods" />
          </div>
          <p class="prize">{{item.mallGoods.goods}}</p>
          <p class="msg">
            <span class="option">{{reducedUnit(item)}}</span>
            <span class="num">剩余{{item.remain}}份</span>
          </p>
          <button
            :class="{btn:true,btnwhite:item.remain<=0}"
            @click="handleExchang($event,item)"
          >{{item.remain>0 ? '兑换':'已兑换光了'}}</button>
        </li>
      </ul>
    </div>
    <div class="shadow" v-show="open.shadow"></div>
    <div class="goodspd samepd" v-if="open.goodslist">
      <GoodsList @cancle="handleClose" @changeInfo="changeInfo" />
    </div>
    <div class="rulepd samepd" v-show="open.Rule">
      <Rule @cancle="handleClose" />
    </div>
    <div class="rulepd samepd" v-if="open.getSW">
      <getSW
        @cancle="handleClose"
        @prompt="handlePrompt"
        @UPdate="handleData"
        :fromGoods="fgoods"
        :buyId="buyId"
      />
    </div>
    <div class="rulepd samepd" v-if="open.getQB">
      <getQB
        @cancle="handleClose"
        @prompt="handlePrompt"
        @UPdate="handleData"
        :fromGoods="fgoods"
        :buyId="buyId"
      />
    </div>
    <div class="rulepd samepd" v-if="open.getHB">
      <Redpacket
        @cancle="handleClose"
        @prompt="handlePrompt"
        @UPdate="handleData"
        :fromGoods="fgoods"
        :buyId="buyId"
      />
    </div>
    <div class="rulepd samepd" v-show="open.login">
      <Login @cancle="handleClose" @prompt="handlePrompt" />
    </div>
    <Prompt v-show="open.prompt" :msg="msg" @cancle="handleEnd" />
    <div class="samepd heightCenter" v-show="open.Download">
      <Dialog>
        <p class="Downmsg">请下载安装雷电圈APP</p>
        <p class="Downmsg">到APP内参加活动</p>
        <div class="Download" @click="DownAPP">官网下载</div>
        <div class="cancle" @click="handleClose"></div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import getSW from "./components/getSW";
import getQB from "./components/getQB";
import Redpacket from "./components/Redpacket";
import GoodsList from "./components/goodsList";
import Rule from "./components/Rule";
import Login from "./components/login";
import Prompt from "./components/Prompt";
import qs from "qs";
import Dialog from "./components/Dialog";
import { login, inventory } from "./utils/config";
export default {
  name: "app",
  components: {
    getSW,
    getQB,
    GoodsList,
    Rule,
    Login,
    Prompt,
    Dialog,
    Redpacket
  },
  data: () => ({
    open: {
      goodslist: false,
      shadow: false,
      Rule: false,
      getSW: false,
      getQB: false,
      getHB: false,
      login: false,
      prompt: false,
      Download: false
    },
    urlarg: {},
    goodsNum: [],
    myoptions: 0,
    msg: "",
    router: false,
    buyId: 0,
    ok: false,
    fgoods: false,
    tab:[
      '积分兑换',
      '红包兑换'
    ],
    current:0
  }),
  created() {
    this.initgoodslist();
  },
  beforeMount() {
    let obj = {};
    let { search } = window.location;
    if (search) {
      let url = search.slice(1).split("&");
      url.map(item => {
        let str = item.split("=");
        obj[str[0]] = str[1];
      });
    } else {
      this.router = true;
      return;
    }
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      method: "post",
      transformRequest: [
        function(data) {
          // 对 data 进行任意转换处理
          return qs.stringify(data);
        }
      ],
      url: login,
      data: {
        uid: obj.uid ? obj.uid : "",
        token: obj.token ? obj.token : ""
      }
    }).then(res => {
      let { data } = res;
      if (data.code == -1) {
        this.handleClose({ type: "login" });
      } else {
        this.myoptions = data.data.points;
      }
    });
  },
  watch:{
    current:function(){
      this.initgoodslist()
    }
  },
  methods: {
    openDownAPP() {
      this.open.Download = !this.open.Download;
      this.open.shadow = !this.open.shadow;
    },
    DownAPP() {
      window.location.href = "http://ldq.ldmnq.com/download";
    },
    handleEnd() {
      if (this.msg.includes("成功")) {
        this.handleClose({ type: "" });
      } else if (this.msg.includes("登录")) {
        this.handleClose({ type: "" });
        this.handleClose({ type: "login" });
      } else {
        this.handlePrompt();
      }
    },
    initgoodslist() {
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url: inventory,
        params:{
          tab:this.current
        }
      }).then(res => {
        let { data } = res.data;
        this.goodsNum = data;
      });
    },
    handleClose(data) {
      if (this.router) {
        // this.openDownAPP();
        return;
      }
      switch (data.type) {
        case "goodslist":
          this.fgoods = true;
          this.open.goodslist = !this.open.goodslist;
          this.open.shadow = !this.open.shadow;
          break;
        case "Rule":
          this.open.Rule = !this.open.Rule;
          this.open.shadow = !this.open.shadow;
          break;
        case "getSW":
          this.open.getSW = !this.open.getSW;
          this.open.shadow = !this.open.shadow;
          break;
        case "getQB":
          this.open.getQB = !this.open.getQB;
          this.open.shadow = !this.open.shadow;
          break;
        case "getHB":
          this.open.getHB = !this.open.getHB;
          this.open.shadow = !this.open.shadow;
          break;
        case "login":
          this.myoptions = data.msg ? data.msg.points : 0;
          this.open.login = !this.open.login;
          this.open.shadow = !this.open.shadow;
          break;
        default:
          this.open.goodslist = false;
          this.open.Rule = false;
          this.open.getSW = false;
          this.open.getQB = false;
          this.open.getHB = false;
          this.open.login = false;
          this.open.shadow = false;
          this.open.prompt = false;
          break;
      }
      if (this.ok) {
        this.open.goodslist = !this.open.goodslist;
        this.open.shadow = !this.open.shadow;
        this.ok = false;
      }
    },
    handleExchang(ev, item) {
      let text = ev.target.innerHTML;
      if (text == "已兑换光了") return;
      if (this.router) {
        // this.openDownAPP();
        return;
      }
      let { type, id } = item.mallGoods;
      if (type == "SW" || type == "QB" || type == "HB") {
        this.fgoods = false;
        this.buyId = id;
        this.handleClose({ type: `get${type}` });
      }
    },
    handlePrompt(msg) {
      if (msg) {
        this.msg = msg;
      }
      this.open.prompt = !this.open.prompt;
    },
    changeInfo(item) {
      let { type, buyId } = item;
      this.handleClose({ type: "goodslist" });
      if (type == "SW" || type == "QB" || type == "HB") {
        this.buyId = buyId;
        this.handleClose({ type: `get${type}` });
        this.ok = true;
      }
    },
    reducedUnit(item) {
      let str = "";
      if (item.points > 0) {
        str += `${item.points}积分 `;
      }
      if (item.lb > 0) {
        str += `${item.lb}雷币 `;
      }
      if (item.fd > 0) {
        str += `${item.fd}福豆 `;
      }
      return str.replace(/ /g, "+").slice(0, -1);
    },
    handleData() {
      this.goodsNum.map(it => {
        if (it.mallGoods.id == this.buyId) {
          this.myoptions -= it.points;
        }
      });
      this.initgoodslist();
    }
  }
};
</script>

<style lang="scss">
body,
html {
  width: 100%;
  height: 100%;
  font-family: "微软雅黑";
}
h1 {
  margin: 0;
  padding: 0;
}
img {
  margin: 0;
  border: none;
}
button {
  outline: none;
  border: none;
}
ul,
li,
p {
  list-style: none;
  padding: 0;
  margin: 0;
}
input,
textarea {
  outline: none;
  border: none;
}

#app {
  max-width: 1080px;
  margin: 0 auto;
  height: 100%;
  .bg {
    width: 100%;
    height: 350px;
    vertical-align: top;
  }
  .Mine {
    width: 100%;
    height: 170px;
    padding: 0 68px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .icon {
        display: block;
        width: 40px;
        height: 44px;
        margin-right: 16px;
      }
      .mypoints {
        font-size: 26px;
        color: #838383;
        margin-right: 20px;
      }
      .points {
        font-size: 50px;
        color: #000;
        font-weight: 600;
      }
    }
    .right {
      display: flex;
      justify-content: space-between;
      .btn {
        padding: 0 50px;
        background: #f2f2f2;
        font-size: 30px;
        border-radius: 45px;
        margin-left: 30px;
        line-height: 90px;
        height: 80px;
      }
    }
  }
  .content {
    padding: 0 80px;
    width: 100%;
    border-top: 28px solid #f2f2f2;
    box-sizing: border-box;
    background: #fff;
    .title {
      font-size: 40px;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      .tab{
        display: block;
        width: 200px;
        text-align: center;
        margin-right: 50px;
        line-height: 70px;
        cursor: pointer;
        border-bottom: 2px solid #fff;
        &:last-child{
          margin-right: 0;
        }
      }
      .on{
        border-bottom: 2px solid #f5c61e;
      }
    }
    .list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        width: 435px;
        font-size: 12px;
        padding-bottom: 30px;
        // height: 458px;
        margin-bottom: 40px;
        border-radius: 20px;
        box-shadow: 0 0 10px #e1e1e1;
        position: relative;
        float: left;
        .img {
          height: 435px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
          img {
          border-radius: 20px 20px 0 0;
           width: 100%;
           height: 100%;
          }
        }
        .prize {
          text-align: center;
          font-size: 35px;
          margin-bottom: 20px;
        }
        .msg {
          display: flex;
          justify-content: space-around;
          margin-bottom: 20px;
          .option {
            font-size: 26px;
            color: #f28d45;
          }
          .num {
            font-size: 26px;
            color: #949494;
          }
        }
        .btn {
          display: block;
          margin:0 auto;
          width: 230px;
          height: 68px;
          line-height: 68px;
          font-size: 28px;
          color: #000;
          border-radius: 40px;
          background: #f5c61e;
        }
        .btnwhite {
          background: #fff;
          border: 1px solid #c0c0c0;
          color: #c0c0c0;
        }
        .empty {
          background: #fff;
          border: 1px solid #c0c0c0;
          color: #c0c0c0;
        }
      }
    }
  }
  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: #000;
    opacity: 0.5;
  }
  .samepd {
    position: fixed;
    z-index: 9999;
    left: 50%;
    transform: translateX(-50%);
  }
  .rulepd {
    top: 25vh;
  }
  .goodspd {
    top: 12vh;
  }
  .heightCenter {
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .Downmsg {
    line-height: 60px;
    font-size: 40px;
    text-align: center;
    margin-bottom: 30px;
  }
  .Download {
    width: 100%;
    height: 110px;
    background: #ffdf32;
    text-align: center;
    line-height: 110px;
    font-size: 32px;
    color: #000;
    border-radius: 8px;
  }
  .cancle {
    position: absolute;
    bottom: -132px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 50px;
    background: url("./assets/guanbi.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
